import { visibleButton } from "../include/module";
import { anchorLink } from "../include/module";



const breakPointPC = 1279;
const breakPointSP = 767;
let resizeFlag     = false;
let windowWidth    = window.innerWidth;
let windowHeight   = window.innerHeight;
let windowWidthJ   = $(window).width();



(() => {
  visibleButton();
  anchorLink();
})();



// WEBPACK FOOTER //
// script.js